
import React from 'react'
import Box from './Box'

/**
 * TextInput component.
 */

export default function TextInput({ ...props }) {
  return <Box
    is="input"
    className="Input"
    type="text"
    {...props} />
}